function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["defaultChecked", "disabled", "helpText", "helpTextProps", "id", "inputProps", "label", "labelPosition", "labelProps", "name", "onBlur", "onChange", "showLabel", "size", "switchProps", "textProps", "wrapperRef"],
  _excluded2 = ["defaultChecked", "disabled", "labelPosition", "look", "showLabel", "size"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useRef, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import { InputLabelPositions, InputLooks } from "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import { SwitchSize } from "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import { mergeRefs } from "../../../../utilities/refs.js";
import { usePrefersReducedMotion } from "../../../../hooks/use-prefers-reduced-motion.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import { fontFamilyBook } from "../../../../themes/fonts.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import { screenReaderOnly } from "../../../../styles/styled-components/screen-reader.js";
import { getSwitchBase, getSwitchUnchecked, getSwitchChecked, getSwitchOutline, getSwitchDisabled, switchSmall, switchSmallOff, switchSmallLabelLeft, switchSmallLabelRight, switchMedium, switchMediumOff, switchMediumLabelLeft, switchMediumLabelRight, switchReducedMotion } from "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import "../../../atoms/icon/font-icon/font-icon.js";
import 'react-transition-group';
import "../../../atoms/alert/inline-alert/inline-alert.js";
import "../../../atoms/alert/standard-alert/standard-alert.js";
import 'boring-avatars';
import "../../../atoms/tooltip/hover-tooltip/hover-tooltip.js";
import 'react-laag';
import '@brandfolder/utilities';
import "../../../atoms/button/close-button/close-button.js";
import "../../../atoms/button/color-button/color-button.js";
import "../../../atoms/button/icon-button/icon-button.js";
import "../../../atoms/button/standard-button/standard-button.js";
import "../../../atoms/loader/circle-loader/circle-loader.js";
import "../../../atoms/loader/shimmer-loader/shimmer-loader.js";
import "../../../atoms/divider/standard-divider/standard-divider.js";
import "../../../atoms/fieldset/standard-fieldset/standard-fieldset.js";
import "../../../atoms/heading/standard-heading/standard-heading.js";
import { StandardLabel } from "../../../atoms/label/standard-label/standard-label.js";
import "../../../atoms/link/button-link/button-link.js";
import "../../../atoms/link/standard-link/standard-link.js";
import "../../../atoms/popout/standard-popout/standard-popout.js";
import "../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js";
import "../../../atoms/table/standard-table/caption.js";
import "../../../atoms/table/standard-table/tbody.js";
import "../../../atoms/table/standard-table/tr-empty.js";
import "../../../atoms/table/standard-table/td.js";
import "../../../atoms/table/standard-table/tr.js";
import "../../../atoms/table/standard-table/table.js";
import "../../../atoms/table/standard-table/tfoot.js";
import "../../../atoms/table/standard-table/th.js";
import "../../../atoms/table/standard-table/thead.js";
import "../../../atoms/table/dnd-table/dnd-handle-td.js";
import "../../../atoms/table/dnd-table/dnd-table-drag-context.js";
import { HelpText } from "../../../atoms/text/help-text/help-text.js";
import "../../../atoms/text/standard-text/standard-text.js";
import "../../../internal/list/standard-list/standard-list.js";
import "../../../internal/listbox/standard-listbox/standard-listbox.js";
import "../../../internal/listitem/standard-listitem/standard-listitem.js";
import "../../../internal/option/standard-option/standard-option.js";
import "../../../internal/textarea/fake-textarea.js";
import "../../../internal/textfield/textfield-addon.js";
import "../../../internal/textfield/textfield-body.js";
import "../../../internal/textfield/textfield-header.js";
import "../../../internal/textfield/textfield-icon.js";
import "../../../internal/textfield/textfield-inner.js";
import { TextfieldWrapper } from "../../../internal/textfield/textfield-wrapper.js";
import { BaseCheckbox } from "../../checkbox/base-checkbox/base-checkbox.js";
import "../../checkbox/standard-checkbox/standard-checkbox.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var UnstyledCheckboxSwitch = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;
  var defaultChecked = props.defaultChecked,
    disabled = props.disabled,
    helpText = props.helpText,
    helpTextProps = props.helpTextProps,
    id = props.id,
    inputProps = props.inputProps,
    label = props.label,
    labelPosition = props.labelPosition,
    labelProps = props.labelProps,
    name = props.name,
    onBlur = props.onBlur,
    onChange = props.onChange,
    showLabel = props.showLabel,
    size = props.size,
    switchProps = props.switchProps,
    textProps = props.textProps,
    wrapperRef = props.wrapperRef,
    otherProps = _objectWithoutProperties(props, _excluded);
  var hasHelpText = !!helpText;
  var helpTextId = "".concat(id, "-help-text");
  var labelId = "".concat(id, "-label");
  var inputRef = useRef(null);
  var prefersReducedMotion = usePrefersReducedMotion();
  return /*#__PURE__*/React.createElement(TextfieldWrapper, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-switch': true,
      'bf-switch__checkbox': true,
      'bf-switch__checkbox--disabled': disabled,
      'bf-switch__checkbox--help-text': hasHelpText
    }, _defineProperty(_classnames, "bf-switch__checkbox--label-".concat(labelPosition), showLabel), _defineProperty(_classnames, 'bf-switch__checkbox--label-hidden', !showLabel), _defineProperty(_classnames, "bf-switch__checkbox--prefers-reduced-motion", prefersReducedMotion), _defineProperty(_classnames, "bf-switch__checkbox--size-".concat(size), size), _defineProperty(_classnames, "".concat(otherProps === null || otherProps === void 0 ? void 0 : otherProps.className), !!(otherProps !== null && otherProps !== void 0 && otherProps.className)), _classnames)),
    labelPosition: labelPosition,
    ref: wrapperRef
  }), /*#__PURE__*/React.createElement(BaseCheckbox, _extends({}, inputProps, {
    "aria-describedby": hasHelpText ? helpTextId : undefined,
    "aria-disabled": disabled,
    className: classnames(_defineProperty({
      'bf-switch__input': true
    }, "".concat(inputProps === null || inputProps === void 0 ? void 0 : inputProps.className), !!(inputProps !== null && inputProps !== void 0 && inputProps.className))),
    defaultChecked: defaultChecked,
    disabled: disabled,
    id: id,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onKeyUp: function onKeyUp(e) {
      var _inputRef$current;
      if (e.key === 'Enter') inputRef === null || inputRef === void 0 || (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.click();
      if (inputProps !== null && inputProps !== void 0 && inputProps.onKeyUp) inputProps.onKeyUp(e);
    },
    ref: mergeRefs([ref, inputRef]),
    role: "switch"
  })), /*#__PURE__*/React.createElement(StandardLabel, _extends({}, labelProps, {
    className: classnames(_defineProperty({
      'bf-switch__label': true
    }, "".concat(labelProps === null || labelProps === void 0 ? void 0 : labelProps.className), !!(labelProps !== null && labelProps !== void 0 && labelProps.className))),
    htmlFor: id,
    id: labelId
  }), /*#__PURE__*/React.createElement("span", _extends({}, switchProps, {
    "aria-hidden": true,
    className: classnames(_defineProperty({
      'bf-switch__switch': true
    }, "".concat(switchProps === null || switchProps === void 0 ? void 0 : switchProps.className), !!(switchProps !== null && switchProps !== void 0 && switchProps.className)))
  })), /*#__PURE__*/React.createElement("span", _extends({}, textProps, {
    className: classnames(_defineProperty({
      'bf-switch__text': true
    }, "".concat(textProps === null || textProps === void 0 ? void 0 : textProps.className), !!(textProps !== null && textProps !== void 0 && textProps.className)))
  }), label)), hasHelpText && /*#__PURE__*/React.createElement(HelpText, _extends({}, helpTextProps, {
    id: helpTextId
  }), helpText));
});
var Switch = styled(UnstyledCheckboxSwitch)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  .bf-switch__label {\n    align-items: center;\n    cursor: pointer;\n    font-family: ", ";\n    font-weight: 400;\n  }\n\n  .bf-switch__input {\n    ", "\n\n    + .bf-switch__label {\n      .bf-switch__switch {\n        ", "\n        ", "\n      }\n    }\n\n    &:checked {\n      + .bf-switch__label {\n        .bf-switch__switch {\n          ", "\n        }\n      }\n    }\n\n    &:focus-visible {\n      + .bf-switch__label {\n        .bf-switch__switch {\n          ", "\n        }\n      }\n    }\n\n    &:disabled {\n      + .bf-switch__label {\n        cursor: not-allowed;\n\n        .bf-switch__switch {\n          ", "\n        }\n      }\n    }\n  }\n\n  &.bf-switch__checkbox--label-hidden {\n    .bf-switch__text {\n      ", "\n    }\n\n    .bf-text__help {\n      ", "\n      margin-left: 0;\n    }\n  }\n\n  &.bf-switch__checkbox--size-small {\n    .bf-switch__input {\n      + .bf-switch__label {\n        .bf-switch__switch {\n          ", "\n\n          &:after {\n            ", "\n          }\n        }\n      }\n\n      &:checked {\n        + .bf-switch__label {\n          .bf-switch__switch {\n            &:after {\n              right: 0;\n            }\n          }\n        }\n      }\n    }\n\n    &.bf-textfield__wrapper--label-position-left {\n      ", "\n    }\n\n    &.bf-textfield__wrapper--label-position-right {\n      ", "\n    }\n  }\n\n  &.bf-switch__checkbox--size-medium {\n    .bf-switch__input {\n      + .bf-switch__label {\n        .bf-switch__switch {\n          ", "\n\n          &:after {\n            ", "\n          }\n        }\n      }\n\n      &:checked {\n        + .bf-switch__label {\n          .bf-switch__switch {\n            &:after {\n              right: 0;\n            }\n          }\n        }\n      }\n    }\n\n    &.bf-textfield__wrapper--label-position-left {\n      ", "\n    }\n\n    &.bf-textfield__wrapper--label-position-right {\n      ", "\n    }\n  }\n\n  &.bf-textfield__wrapper--label-position-left {\n    align-items: flex-end;\n\n    .bf-switch__switch {\n      order: 1;\n    }\n  }\n\n  &.bf-switch__checkbox--prefers-reduced-motion {\n    .bf-switch__input {\n      + .bf-switch__label {\n        .bf-switch__switch {\n          ", "\n        }\n      }\n    }\n  }\n"])), fontFamilyBook, screenReaderOnly, function () {
  return getSwitchBase();
}, function (_ref) {
  var look = _ref.look;
  return getSwitchUnchecked({
    look: look
  });
}, function (_ref2) {
  var look = _ref2.look;
  return getSwitchChecked({
    look: look
  });
}, function (_ref3) {
  var look = _ref3.look;
  return getSwitchOutline({
    look: look
  });
}, function (_ref4) {
  var look = _ref4.look;
  return getSwitchDisabled({
    look: look
  });
}, screenReaderOnly, screenReaderOnly, switchSmall, switchSmallOff, switchSmallLabelLeft, switchSmallLabelRight, switchMedium, switchMediumOff, switchMediumLabelLeft, switchMediumLabelRight, switchReducedMotion);
/**
 * A `CheckboxSwitch` represents on/off values using `<input role="switch" type="checkbox" />` for compatibility with forms.
 *
 * This component differs from `ImmediateSwitch` in that `CheckboxSwitch` is meant to be used within a `<form>`,
 * whereas `ImmediateSwitch` is not. An example implementation using this component with a `<form>`
 * via `react-hook-form` is in the companion Examples story.
 *
 * Required attributes for `CheckboxSwitch` are `id` and `label`.
 * Common optional attributes include `defaultChecked`, `disabled`, and `helpText`.
 * You may hide the label visually (but still be accessible to screen readers) by passing `showLabel={false}`,
 * though this is not recommended.
 *
 * `CheckboxSwitch` sizing defaults to `SwitchSize.Small` (16px circle),
 * with a `SwitchSize.Medium` available (24px circle).
 *
 * Labels may be placed on the right hand side via `InputLabelPositions.Right` (default)
 * or on the left via `InputLabelPositions.Left`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/switch_role
 *
 * https://www.w3.org/WAI/ARIA/apg/patterns/switch/examples/switch-checkbox/
 */
var CheckboxSwitch = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$defaultChecked = props.defaultChecked,
    defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? InputLabelPositions.Right : _props$labelPosition,
    _props$look = props.look,
    look = _props$look === void 0 ? InputLooks.Default : _props$look,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
    _props$size = props.size,
    size = _props$size === void 0 ? SwitchSize.Small : _props$size,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Switch, _extends({}, otherProps, {
    defaultChecked: defaultChecked,
    disabled: disabled,
    labelPosition: labelPosition,
    look: look,
    ref: ref,
    showLabel: showLabel,
    size: size
  })));
});
export { CheckboxSwitch, UnstyledCheckboxSwitch };